export { default } from "./CompareAccordion";
export * from "./CompareAccordion";
